import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

function Date(props: Readonly<SvgIconProps>): JSX.Element {
  return (
    <SvgIcon height='24px' viewBox='0 -960 960 960' width='24px' fill='#000' {...props}>
      <path d='M532-700v-60h348v60H532Zm0 160v-60h348v60H532Zm0 160v-60h348v60H532Zm-212-23q-51 0-84.5-33.5T202-521q0-51 33.5-84.5T320-639q51 0 84.5 33.5T438-521q0 51-33.5 84.5T320-403ZM80-160v-66q0-18.86 9-35.93T113-286q45-32 98.5-47.5T320-349q55 0 108 17t99 46q14 10 23.5 25.5T560-226v66H80Zm55-71v11h370v-11q-39-26-90-42t-95-16q-44 0-95.5 16T135-231Zm185-232q26 0 42-16t16-42q0-26-16-42t-42-16q-26 0-42 16t-16 42q0 26 16 42t42 16Zm0-58Zm0 301Z' />
    </SvgIcon>);
}

export default React.memo(Date);
